import React from "react";
import { Text, View } from "@react-pdf/renderer";

import TextAreaLabel from "../../../../exportacion_react_pdf/TextAreaLabel";
import SelectGroup from "../../../../exportacion_react_pdf/SelectGroup";
import QuestionResponse from "../../../../exportacion_react_pdf/QuestionResponse";
import CheckboxGroup from "../../../../exportacion_react_pdf/CheckboxGroup";

// Define el documento
const ExportServicioPaso6 = ({ formData, styles }) => (
  <>
    {/* Sección de Identificació del proyecto */}
    <View style={styles.section}>
      <Text style={styles.title_1}>SERVICIOS</Text>

      <SelectGroup
        label={"Tipo de servicio"}
        selectedValue={formData?.servicios?.tipo_de_servicio || []}
      ></SelectGroup>

      {(formData?.servicios?.tipo_de_servicio ?? []).includes("Otro") && (
        <QuestionResponse
          label={"¿Cuál otro tipo de servicio?"}
          value={formData?.servicios?.otro_tipo_de_servicio || ""}
        />
      )}

      <CheckboxGroup
        label="¿Cuenta actualmente con los equipos necesarios para la prestación de su servicio?"
        selectedValue={formData?.servicios?.cuenta_con_equipos_necesarios || ""}
      ></CheckboxGroup>

      {formData?.servicios?.cuenta_con_equipos_necesarios === "Sí" && (
        <>
          <QuestionResponse
            label={"Cuál es el estado de esos equipos?"}
            value={formData?.servicios?.estado_equipos || ""}
          ></QuestionResponse>

          <QuestionResponse
            label={
              "¿Con qué frecuencia lleva a cabo el mantenimiento de las máquinas o insumos con los cuales cuenta?"
            }
            value={formData?.servicios?.frecuencia_mantenimiento_maquinas || ""}
          ></QuestionResponse>
        </>
      )}

      <QuestionResponse
        label={
          "La demanda del servicio en la zona donde se encuentra actualmente es"
        }
        value={formData?.servicios?.demanda_servicio_actualmente || ""}
      ></QuestionResponse>

      <CheckboxGroup
        label="Cuenta con espacio  para el almacenamiento de insumos, materiales y herramientas"
        selectedValue={
          formData?.servicios?.cuenta_con_espacio_almacenamiento_insumos || ""
        }
      ></CheckboxGroup>

      <TextAreaLabel
        label={
          "Qué actividades realiza para el mantenimiento de los equipos con los cuales cuenta?"
        }
        value={
          formData?.servicios?.actividades_realiza_mantenimiento_equipos || ""
        }
      ></TextAreaLabel>

      <CheckboxGroup
        label="¿Cuenta con los elementos de protección necesarios para la prestación del servicio?"
        selectedValue={
          formData?.servicios?.cuenta_con_elementos_proteccion || ""
        }
      ></CheckboxGroup>

      <CheckboxGroup
        label="La prestación del servicio se da"
        selectedValue={formData?.servicios?.presentacion_del_servicio || ""}
        options={["Veredal", "Municipal", "Departamental", "Nacional"]}
      ></CheckboxGroup>

      <SelectGroup
        label={"¿Cómo adquiero el conocimiento del servicio que ofrece?"}
        selectedValue={
          formData?.servicios?.como_adquiero_conocimiento_ofrecido || []
        }
      ></SelectGroup>

      {(
        formData?.servicios?.como_adquiero_conocimiento_ofrecido ?? []
      ).includes("Otro") && (
        <QuestionResponse
          label={"¿Cual otro?"}
          value={
            formData?.servicios?.otro_como_adquiero_conocimiento_ofrecido || ""
          }
        />
      )}

      <CheckboxGroup
        label="¿Brinda algún tipo de garantía por el servicio prestado?"
        selectedValue={formData?.servicios?.brinda_garantia_servicio || ""}
      ></CheckboxGroup>

      <CheckboxGroup
        label="¿Cuenta con un portafolio de los servicios que ofrece?"
        selectedValue={formData?.servicios?.cuenta_portafolio_servicios || ""}
      ></CheckboxGroup>
    </View>
  </>
);

export default ExportServicioPaso6;
